import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './LocationServiceSettings.css';
import LocationServiceSettings from '../../../components/SiteAdmin/Location/LocationServiceSettings/LocationServiceSettings';
import getLocationServiceSettingQuery from './getLocationServiceSetting.graphql';

class LocationServiceSettingsPage extends Component {
    render() {
        const { data, locationId } = this.props;

        return (
            <LocationServiceSettings
                locationId={locationId}
                settingData={data}
            />
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getLocationServiceSettingQuery, {
        options: (props) => ({
            variables: { locationId: props.locationId },
            fetchPolicy: 'network-only',
        }),
    })
)(LocationServiceSettingsPage);
